import React from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHeartPulse } from "@fortawesome/free-solid-svg-icons";
import { useSystemHealth } from "../../hooks/admin/useSystemHealth";

const STATUS_COLOR = {
  ok: "text-green-400",
  degraded: "text-amber-400",
  down: "text-red-400",
  unknown: "text-white/50",
};

/**
 * Subtle heartbeat icon (admin-only) that links to /admin/health and tints
 * itself by the overall system status, so it doubles as an at-a-glance signal.
 * Pulses when something is degraded or down.
 */
const HealthIndicator = ({ showLabel = false, onClick }) => {
  const { data, isLoading, isError } = useSystemHealth();

  const status = isError
    ? "down"
    : isLoading
      ? "unknown"
      : data?.status || "unknown";
  const color = STATUS_COLOR[status] || STATUS_COLOR.unknown;
  const pulse = status === "down" || status === "degraded";

  return (
    <Link
      to="/admin/health"
      onClick={onClick}
      title={`System health: ${status}`}
      aria-label={`System health: ${status}`}
      className={
        showLabel
          ? "flex items-center gap-2 py-3 px-4 min-h-[48px] text-white hover:text-gold hover:bg-white/5 transition-colors"
          : "flex items-center justify-center min-h-[44px] min-w-[44px] md:min-h-0 md:min-w-0 md:px-2 text-white/70 hover:text-white transition-colors"
      }
    >
      <FontAwesomeIcon
        icon={faHeartPulse}
        className={`w-4 h-4 ${color} ${pulse ? "animate-pulse" : ""}`}
      />
      {showLabel && <span>System Health</span>}
    </Link>
  );
};

export default HealthIndicator;
